export class PathsStorages {

    public vehicles = 'vehicles/';
}
